import PropTypes from 'prop-types';
// @flow

import Switch from 'react-bootstrap-switch';

import React, { Component } from 'react';
import I18n from 'PMT/i18n/I18n';

import { CurrencyUtils } from 'PMT/utils';

// -- entities
import ProductOptionValue from 'PMT/entities/menu/ProductOptionValue';

import SortableList from 'PMT/components/SortableList';
import { getAllergenLabel } from 'PMT/constants/DietaryConstants';

export default class ProductOptionValueRow extends Component {
  static propTypes = {
    productOptionValue: PropTypes.objectOf(ProductOptionValue).isRequired,
    currencyCode: PropTypes.string,


    /**
     * @param ProductOptionValue
     */
    onEditClicked: PropTypes.func.isRequired,

    readOnly: PropTypes.bool.isRequired,
  };

  shouldComponentUpdate(nextProps) {
    return !nextProps.productOptionValue.equals(this.props.productOptionValue);
  }

  // -- getters

  get productOptionValue() {
    return this.props.productOptionValue;
  }

  get currencyCode(): string {
    return this.props.currencyCode;
  }

  get formattedPrice() {
    if (this.productOptionValue.additionalPrice !== 0) {
      return `(+${CurrencyUtils.formatPriceWithCurrency(
        this.productOptionValue.additionalPrice,
          this.currencyCode
      )})`;
    }
    return I18n.tr('menu.product_option.option.value.no_additionnal_price');
  }

  // -- renderers

  render() {
    const { readOnly } = this.props;

    return (
      <div className="row product_option_edit__value_row">
        <div className="product_option_edit__value_row__name col-xs-4">
          {this.productOptionValue.name}
        </div>
        <div className="product_option_edit__value_row__price col-xs-2">
          {this.formattedPrice}
        </div>
        <div className="product_option_edit__value_row__price col-xs-2">
          {this.productOptionValue.dietaryInfo && (
            <span>
              {(this.productOptionValue.dietaryInfo.allergens || [])
                .map(getAllergenLabel)
                .join(', ')}
            </span>
          )}
        </div>

        <div className="col-xs-2">
          <Switch
            bsSize="mini"
            wrapperClass="switch_important"
            value={this.productOptionValue.haveStock()}
            disabled
          />
        </div>

        {!readOnly && (
          <div
            className="product_option_edit__value_row__edit col-xs-1"
            onClick={() => this.props.onEditClicked(this.productOptionValue)}
          >
            <i className="fa fa-edit" />
          </div>
        )}

        {!readOnly && (
          <div className="product_option_edit__value_row__drag_handle col-xs-1">
            <SortableList.DragHandle />
          </div>
        )}
      </div>
    );
  }
}



// WEBPACK FOOTER //
// ./scripts/pages/menu/optionEdit/components/ProductOptionValueRow.js